(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectSopService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1843,
                    parameters: parms || {}
                });
            },
            listChoices: function (parms) {
                return $ihttp.post({
                    method: 1852,
                    parameters: parms || {}
                });
            },
            changeProduct: function (edit) {
                return $ihttp.post({
                    method: 1845,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1844,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
